import { render } from "./CommunityField.vue?vue&type=template&id=3aa749d5"
import script from "./CommunityField.vue?vue&type=script&lang=js"
export * from "./CommunityField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__